import { SectionsModel } from "../Sections/SectionsModel";

export class SubsectionModel {
    id?: number;
    subsection_id?: number;
    name?: string;
    subsection_name?: string;
    description?: string;
    section?: SectionsModel;
    created_at?: string;
    updated_at?: string;
    deleted_at?: string;
}